import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import { AuthProvider } from './AuthContext'

import { ErrorBoundary } from './ErrorBoundary'

// Startup logs removed

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})

// Функция для принудительного обновления кэша
const clearCache = async () => {
  try {
    // Очищаем кэш браузера
    if ('caches' in window) {
      const cacheNames = await caches.keys()
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      )
      // Cache cleared
    }

    // Очищаем Service Worker
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(
        registrations.map(registration => registration.unregister())
      )
              // Service Worker unregistered
    }
  } catch (error) {
    console.error('❌ Error clearing cache:', error)
  }
}

// Очищаем кэш при загрузке
clearCache()

// Starting React render

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
      // React rendered successfully
} catch (error) {
  console.error('💥 React render failed:', error)
} 